// removed by extract-text-webpack-plugin
module.exports = {"dialog":"call-module-dialog-b4933ee22df3fc4419e2db4ba077f6af--","overlay-container":"call-module-overlay-container-e90aa9d7e6c78a4082c921c6311d7769--"};


//////////////////
// WEBPACK FOOTER
// /src/components/call/call.module.scss
// module id = 1892
// module chunks = 0